export default __webpack_public_path__ + "static/media/file-with-search.8dd2ddb9.svg";